import React, { Fragment, Component } from 'react';
import { Field, reduxForm, FieldArray, formValueSelector } from 'redux-form';
import { renderField, renderTextArea, renderSelectField, renderCurrency, AsyncSelectField, SelectField } from '../../../Utils/renderField';
import { api } from 'api';


class ItemArray extends Component {
    state = {
    }

    constructor(props) {
        super(props);
        // Crea una referencia para guardar el elemento textInput del DOM
        // this.textInputDespachos = React.createRef();
    }

    componentDidUpdate(prevProps, prevState) {
    }

    render() {
        const { index, field, elemento, item, eliminar } = this.props;

        return (
            <tr key={index} style={{ height: "68px" }}>
                <td className="text-center sin-borde-top" style={{width: "48px"}}>
                    <img className="action-img" src={require('assets/img/icons/Cerrar.png')} alt="Borrar"
                        title="Borrar"
                        onClick={() =>{
                            eliminar()
                        }}
                    />
                </td>
                <td className="sin-borde-top" >
                    <Field
                        name={`${field}.descripcion`}
                        type="text"
                        // min="0" max="5"
                        component={renderField}
                        top ={{top:"67px", position:"inherit"}}
                    />
                </td>
            </tr>
        );
    }
}


const RenderOtro = ({
    fields,
    meta: { error, submitFailed, form },
    dispatch,
    item, reRender, esEdicion,
    }) => (
    <div className=" col-sm-12 p-0">
        <div className=" col-sm-12 form-group np-r p-0">
            <div className="col-sm-12 form-group np-r  mt-2 sin-borde p-0 color-header-tabla">
                <table className="table table-sm table-responsive-sm m-0 table-striped">
                    <thead>
                        <tr>
                            <th ></th>
                            <th>Descripcion</th>
                        </tr>
                    </thead>
                    <tbody>
                        {fields.map((field, index) => {
                            return (
                                <ItemArray
                                    dispatch={dispatch} // Para actualizar las bodegas
                                    form={form} // Para actualizar las bodegas

                                    key={index}
                                    index={index}
                                    field={field}
                                    item={item} // Instancia del tinerario
                                    elemento={fields ? fields.get(index) : null} // Elemento de los detalles
                                    esEdicion={esEdicion}
                                    eliminar={() => {
                                        fields.remove(index)
                                    }}
                                />
                            );

                        })}
                    </tbody>
                </table>
            </div>
            <div className="d-flex justify-content-start mt-2">
                {
                    fields.length === 0 && (
                        <button type="button" className="btn btn-primary" onClick={() => fields.push({})}>
                            +
                        </button>
                    )
                }
            </div>
        </div>
        {submitFailed &&
            error &&
            <div className="invalid-feedback-array text-danger">
                {error}
            </div>}
    </div>
)

export default RenderOtro;